<template>
    <div>
        <div class="font-weight-bold">{{product.name}}</div>

        <div v-html="product.description" />

        <div v-if="product.auto" class="my-1">
            <v-icon color="primary">mdi-refresh</v-icon>
            {{$translate('Recurring, automatically extended')}}
        </div>

        <div v-else-if="product.period" class="my-1">
            <v-icon color="primary">mdi-calendar-clock</v-icon>
            {{$translate('Valid from')}} {{product.periodValidFrom}} {{$translate('to')}} {{product.periodValidTo}}
        </div>

        <div v-else-if="product.validTime" class="my-1">
            <div v-if="product.validFromDate">
                <v-icon color="primary">mdi-calendar-clock</v-icon>
                {{$translate('Valid until')}} {{ calculateAndFormatEndDate(product.validFromDate) }}
            </div>
            <div v-else>
                <v-icon color="primary">mdi-calendar-clock</v-icon>
                {{$translate('Valid for')}} {{product.validTime}} {{$translate(product.validType + (product.validTime === 1 ? '' : 's')).toLowerCase()}} {{$translate('from purchase')}}
            </div>
        </div>

        <div v-if="product.boundTime" class="my-1">
            <v-icon color="primary">mdi-calendar-clock</v-icon>
            {{$translate('Bound for')}} {{product.boundTime}} {{$translate(product.boundType + (product.boundTime === 1 ? '' : 's')).toLowerCase()}}
        </div>

        <div v-if="product.trainingsessions" class="my-1">
            <v-icon color="primary">mdi-ticket-confirmation-outline</v-icon> {{product.trainingsessions}} {{$translate('Punch tickets').toLowerCase()}}
        </div>

        <div v-if="product.workout" class="my-1">
            <v-icon color="primary">mdi-ticket-confirmation-outline</v-icon> {{$translate('Workout booking included')}}
        </div>

        <div v-if="product.entry" class="my-1">
            <v-icon color="primary">mdi-door-closed-lock</v-icon> {{$translate('Enables on-site access')}}
        </div>
    </div>
</template>

<script>
export default {
    name: 'zoezi-training-card-product-info',

    zoezi: {
        title: 'Training Card Product Info',
        icon: 'mdi-information'
    },

    props: {
        product: {
            type: Object,
            required: true
        }
    },

    methods: {
        calculateAndFormatEndDate(date) {
            let dateObj = Date.newFull(date);
            dateObj.setDate(dateObj.getDate() - 1);
            return Date.formatFullShorter(dateObj);
        },
    }
};
</script>
